import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * アポイントメントデータ一覧
 *
 * 自分が所持しているアポイントメントの一覧を返す
 */
export class FetchSchedule implements APIRequest<Monitaro.FetchScheduleResponse> {
  response: Monitaro.FetchScheduleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/schedules`
  }
}

/**
 * アポイントメントデータの取得
 *
 * 指定されたアポイントメントIDのデータを取得する&lt;br&gt;
保有していないアポイントメントIDの場合はステータス404を返す
 */
export class GetSchedule implements APIRequest<Monitaro.GetScheduleResponse> {
  response: Monitaro.GetScheduleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(appointment: string) {
    this.path = `/schedules/${appointment}`
  }
}
